import React, { useEffect, useMemo, useState } from 'react';
import classNames from 'classnames';
import { Icon, IconsEnum } from 'components/Icons';
import { getCookie } from 'lib/persist/cookie';
import { DynamicImage, enLoading } from 'components/Image';
import { isNotEmpty } from 'utility/functions';
import styles from './InstantPanel.module.scss';
import { InstantPanel, TriggerProps } from '.';

export const Trigger = ({ image }: TriggerProps) => {
  const [imgOK, setImgOK] = useState(true);
  const [disabled, setDisabled] = useState<boolean>(false);

  const [isOpen, setOpen] = useState(false);
  const [isVisible, setVisible] = useState(false);

  const doToggle = () => {
    setVisible(true);
    setOpen(true);
  };

  useEffect(() => {
    const get = getCookie('instant-roulette-disabled');
    if (get) {
      setDisabled(true);
    }
  }, []);

  const objToggler = useMemo(() => {
    const { url, alt } = image ?? {};
    if (imgOK && isNotEmpty(url)) {
      return (
        <DynamicImage
          src={url}
          alt={alt ?? ''}
          width={40}
          height={40}
          loading={enLoading.lazy}
          decoding="async"
          className={styles.instantIcon}
          onError={() => setImgOK(false)}
        />
      );
    } else {
      return <Icon iconId={IconsEnum.INSTANT_PANEL} className={styles.instantIcon} />;
    }
  }, [image, imgOK]);

  return (
    <React.Fragment>
      <button
        id="openButton"
        type="button"
        disabled={disabled}
        className={classNames(styles.openButton)}
        onClick={doToggle}
      >
        {objToggler}
      </button>
      {isOpen && <InstantPanel doToggle={setVisible} isVisible={isVisible} />}
    </React.Fragment>
  );
};
